// /forge/interest — Interest phase page.
//
// Wraps the existing Interest/TAM dashboard as the "Overview" tab and folds
// Geography in as its own tab (previously /forge/geography standalone).
// Remaining tabs are placeholders; PR C adds Channel Attribution detail and
// Interest → Application conversion metrics.

import { lazy, Suspense } from "react";
import PhaseTabs, { PlaceholderTab } from "../../components/shared/PhaseTabs";
import InterestContent from "./InterestContent";

const Geography = lazy(() => import("./Geography"));

function GeographyLoading() {
  return (
    <div className="glass rounded-xl p-12 text-center text-theme-muted text-sm">
      Loading geography map…
    </div>
  );
}

export default function Interest() {
  return (
    <PhaseTabs
      eyebrow="FORGE · Interest"
      title="Interest"
      subtitle="Top of the funnel — awareness, TAM, geography, and channel attribution."
      tabs={[
        {
          key: "overview",
          label: "Awareness & TAM",
          content: <InterestContent />,
        },
        {
          key: "geography",
          label: "Geography",
          content: (
            <Suspense fallback={<GeographyLoading />}>
              <Geography />
            </Suspense>
          ),
        },
        {
          key: "channels",
          label: "Channels",
          placeholder: true,
          content: (
            <PlaceholderTab hint="Per-channel attribution once Typeform UTM fields are live. Cost-per-submission, per-channel conversion, top-of-funnel ROI." />
          ),
        },
        {
          key: "conversion",
          label: "Interest → Application",
          placeholder: true,
          content: (
            <PlaceholderTab hint="Conversion funnel from interest-form submission through to Application-phase entry. Drop-off by channel, persona, and geography." />
          ),
        },
      ]}
    />
  );
}
